export default "__VITE_ASSET__Cjz6euLi__"